import { useEffect } from 'react';
import { useMantineColorScheme } from '@mantine/core';
import { applyThemeVariables } from './theme';

export function ThemeProvider({ children }: { children: React.ReactNode }) {
	const { colorScheme } = useMantineColorScheme();

	useEffect(() => {
		applyThemeVariables(colorScheme);
	}, [colorScheme]);

	return <>{children}</>;
}
